import React from 'react';
import { Controller } from 'react-hook-form';

/**
 * BankTab — BANK DETAILS tab
 * Includes precise Bootstrap 5 horizontal layouts and 5-column grids
 * where labels display on top of their inputs inside the grid.
 */
const BankTab = ({ control, watch, errors }) => {
  const rolloverType = watch('rolloverType');

  return (
    <div className="w-100">
      {/* ── BANK DETAILS Section ── */}
      <h5 className="de-section-title">BANK DETAILS</h5>

      {/* Row 1: Upfront Charges & Foreign Bank Name */}
      <div className="row g-3">
        <div className="col-12 col-lg-4">
          <div className="row align-items-center g-2">
            <label className="col-5 col-form-label de-label text-start">UPFRONT CHARGES :</label>
            <div className="col-7">
              <Controller
                name="upFrontCharges"
                control={control}
                render={({ field }) => (
                  <input {...field} type="number" className="form-control" placeholder="Upfront Charges" />
                )}
              />
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-8">
          <div className="row align-items-center g-2">
            <label className="col-form-label de-label text-start de-label-span-2">FOR. BANK NAME :</label>
            <div className="de-input-span-2">
              <Controller
                name="foreignBankName"
                control={control}
                render={({ field }) => (
                  <input {...field} type="text" className="form-control" placeholder="Foreign Bank Name" />
                )}
              />
            </div>
          </div>
        </div>
      </div>

      {/* M1 Row (5 columns, labels on top) */}
      <div className="de-form-grid de-cols-5 mt-3">
        <div className="de-field-group">
          <label className="de-label mb-1">M1 NUMBER :</label>
          <Controller
            name="M1AccountNumber"
            control={control}
            render={({ field }) => (
              <input {...field} type="text" className="form-control" placeholder="M1 Account No" />
            )}
          />
        </div>
        <div className="de-field-group">
          <label className="de-label mb-1">M1 DATE :</label>
          <Controller
            name="bankDetailsM1Date"
            control={control}
            render={({ field }) => (
              <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
            )}
          />
        </div>
        <div className="de-field-group">
          <label className="de-label mb-1">M1 VALUE :</label>
          <Controller
            name="margin10"
            control={control}
            render={({ field }) => (
              <input {...field} type="number" className="form-control" placeholder="Margin 10" />
            )}
          />
        </div>
        <div className="de-field-group">
          <label className="de-label mb-1">M1- DOM :</label>
          <Controller
            name="bankDetailsM1Dom"
            control={control}
            render={({ field }) => (
              <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
            )}
          />
        </div>
        <div className="de-field-group">
          <label className="de-label mb-1">M1- MV :</label>
          <Controller
            name="bankDetailsM1Mv"
            control={control}
            render={({ field }) => (
              <input {...field} type="text" className="form-control" placeholder="M1 MV" />
            )}
          />
        </div>
      </div>

      {/* M2 Row (5 columns, labels on top) */}
      <div className="de-form-grid de-cols-5 mt-3">
        <div className="de-field-group">
          <label className="de-label mb-1">M2 NUMBER :</label>
          <Controller
            name="M2AccountNumber"
            control={control}
            render={({ field }) => (
              <input {...field} type="text" className="form-control" placeholder="M2 Account No" />
            )}
          />
        </div>
        <div className="de-field-group">
          <label className="de-label mb-1">M2 DATE :</label>
          <Controller
            name="bankDetailsM2Date"
            control={control}
            render={({ field }) => (
              <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
            )}
          />
        </div>
        <div className="de-field-group">
          <label className="de-label mb-1">M2 VALUE :</label>
          <Controller
            name="margin5"
            control={control}
            render={({ field }) => (
              <input {...field} type="number" className="form-control" placeholder="Margin 5" />
            )}
          />
        </div>
        <div className="de-field-group">
          <label className="de-label mb-1">M2-DOM :</label>
          <Controller
            name="bankDetailsM2Dom"
            control={control}
            render={({ field }) => (
              <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
            )}
          />
        </div>
        <div className="de-field-group">
          <label className="de-label mb-1">M2-MV :</label>
          <Controller
            name="bankDetailsM2Mv"
            control={control}
            render={({ field }) => (
              <input {...field} type="text" className="form-control" placeholder="M2 MV" />
            )}
          />
        </div>
      </div>

      {/* BG charges Row (5 columns, labels on top) */}
      <div className="de-form-grid de-cols-5 mt-3">
        <div className="de-field-group">
          <label className="de-label mb-1">BG NUMBER :</label>
          <Controller
            name="bgNumber"
            control={control}
            render={({ field }) => (
              <input {...field} type="text" className="form-control" placeholder="BG Number" />
            )}
          />
        </div>
        <div className="de-field-group">
          <label className="de-label mb-1">BG DATE :</label>
          <Controller
            name="bgDate"
            control={control}
            render={({ field }) => (
              <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
            )}
          />
        </div>
        <div className="de-field-group">
          <label className="de-label mb-1">BG CHARGES :</label>
          <Controller
            name="bgCharges"
            control={control}
            render={({ field }) => (
              <input {...field} type="number" className="form-control" placeholder="BG Charges" />
            )}
          />
        </div>
        <div className="de-field-group">
          <label className="de-label mb-1">SBLC INT & CHARGES :</label>
          <Controller
            name="sblcInterestCharges"
            control={control}
            render={({ field }) => (
              <input {...field} type="number" className="form-control" placeholder="SBLC Interest & Charges" />
            )}
          />
        </div>
        <div className="de-field-group">
          <label className="de-label mb-1">DUE DATE :</label>
          <Controller
            name="dueDate"
            control={control}
            render={({ field }) => (
              <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
            )}
          />
        </div>
      </div>

      {/* Advice charges Row (5 columns, labels on top) */}
      <div className="de-form-grid de-cols-5 mt-3">
        <div className="de-field-group">
          <label className="de-label mb-1">ADVICE :</label>
          <Controller
            name="advice"
            control={control}
            render={({ field }) => (
              <input {...field} type="text" className="form-control" placeholder="Advice" />
            )}
          />
        </div>
        <div className="de-field-group">
          <label className="de-label mb-1">ADVICE GST :</label>
          <Controller
            name="adviceGst"
            control={control}
            render={({ field }) => (
              <input {...field} type="text" className="form-control" placeholder="Advice GST" />
            )}
          />
        </div>
        <div className="de-field-group">
          <label className="de-label mb-1">EXCHANGE RATE :</label>
          <Controller
            name="exchangeRate"
            control={control}
            render={({ field }) => (
              <input {...field} type="number" className="form-control" placeholder="Exchange Rate" />
            )}
          />
        </div>
        <div className="de-field-group">
          <label className="de-label mb-1">BANK DEDUCT DATE :</label>
          <Controller
            name="bankDeductionDate"
            control={control}
            render={({ field }) => (
              <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
            )}
          />
        </div>
        <div className="de-field-group">
          <label className="de-label mb-1">FWD COVER DATE :</label>
          <Controller
            name="forwardContractDate"
            control={control}
            render={({ field }) => (
              <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
            )}
          />
        </div>
      </div>

      {/* FWD COVERED AMT Row */}
      <div className="row g-3 mt-2">
        <div className="col-12 col-lg-4">
          <div className="row align-items-center g-2">
            <label className="col-5 col-form-label de-label text-start">FWD COVERED AMT :</label>
            <div className="col-7">
              <Controller
                name="forwardcontractamount"
                control={control}
                render={({ field }) => (
                  <input {...field} type="number" className="form-control" placeholder="Forward Covered Amt" />
                )}
              />
            </div>
          </div>
        </div>
      </div>

      <hr className="de-section-divider my-4" />

      {/* ── Rollover Selector ── */}
      <div className="row g-3 align-items-center">
        <div className="col-12 col-md-6 col-lg-4">
          <Controller
            name="rolloverType"
            control={control}
            render={({ field }) => (
              <select {...field} className="form-select fw-bold">
                <option value="">NO ROLLOVER</option>
                <option value="same">ROLLOVER SAME BG</option>
                <option value="new">ROLLOVER NEW BG</option>
              </select>
            )}
          />
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <Controller
            name="rolloverdays"
            control={control}
            render={({ field }) => (
              <input {...field} type="number" className="form-control" placeholder="Tenor Days" />
            )}
          />
        </div>
      </div>

      {/* Same BG Rollover Details */}
      {rolloverType === 'same' && (
        <div className="mt-4 p-3 bg-light rounded border">
          <div className="row g-3">
            <div className="col-12 col-lg-4">
              <div className="row align-items-center g-2">
                <label className="col-5 col-form-label de-label text-start">UPFRONT CHARGES :</label>
                <div className="col-7">
                  <Controller
                    name="rolloverSameBgUpfrontCharges"
                    control={control}
                    render={({ field }) => <input {...field} type="number" className="form-control" />}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-8">
              <div className="row align-items-center g-2">
                <label className="col-form-label de-label text-start de-label-span-2">FOR. BANK NAME :</label>
                <div className="de-input-span-2">
                  <Controller
                    name="rolloverSameBgForeignBankName"
                    control={control}
                    render={({ field }) => <input {...field} type="text" className="form-control" placeholder="Foreign Bank Name" />}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* M3 details row */}
          <div className="de-form-grid de-cols-5 mt-3">
            <div className="de-field-group">
              <label className="de-label mb-1">M3 :</label>
              <Controller
                name="rolloverSameBgM3"
                control={control}
                render={({ field }) => <input {...field} type="text" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">M3 DATE :</label>
              <Controller
                name="rolloverSameBgM3Date"
                control={control}
                render={({ field }) => (
                  <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">M3 VALUE :</label>
              <Controller
                name="rolloverSameBgM3Value"
                control={control}
                render={({ field }) => <input {...field} type="number" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">M3- DOM :</label>
              <Controller
                name="rolloverSameBgM3Dom"
                control={control}
                render={({ field }) => (
                  <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">M3- MV :</label>
              <Controller
                name="rolloverSameBgM3Mv"
                control={control}
                render={({ field }) => <input {...field} type="text" className="form-control" />}
              />
            </div>
          </div>

          {/* BG charges row */}
          <div className="de-form-grid de-cols-5 mt-3">
            <div className="de-field-group">
              <label className="de-label mb-1">BG NUMBER :</label>
              <Controller
                name="rolloverSameBgBgNumber"
                control={control}
                render={({ field }) => <input {...field} type="text" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">BG DATE :</label>
              <Controller
                name="rolloverSameBgBgDate"
                control={control}
                render={({ field }) => (
                  <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">BG CHARGES :</label>
              <Controller
                name="rolloverSameBgBgCharges"
                control={control}
                render={({ field }) => <input {...field} type="number" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">SBLC INT & CHARGES :</label>
              <Controller
                name="rolloverSameBgSblcInterestCharges"
                control={control}
                render={({ field }) => <input {...field} type="number" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">DUE DATE :</label>
              <Controller
                name="rolloverSameBgDueDate"
                control={control}
                render={({ field }) => (
                  <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
          </div>

          {/* Advice row */}
          <div className="de-form-grid de-cols-5 mt-3">
            <div className="de-field-group">
              <label className="de-label mb-1">ADVICE :</label>
              <Controller
                name="rolloverSameBgAdvice"
                control={control}
                render={({ field }) => <input {...field} type="text" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">ADVICE GST :</label>
              <Controller
                name="rolloverSameBgAdviceGst"
                control={control}
                render={({ field }) => <input {...field} type="text" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">EXCHANGE RATE :</label>
              <Controller
                name="rolloverSameBgExchangeRate"
                control={control}
                render={({ field }) => <input {...field} type="number" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">BANK DEDUCT DATE :</label>
              <Controller
                name="rolloverSameBgBankDeductingDate"
                control={control}
                render={({ field }) => (
                  <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">FWD COVER DATE :</label>
              <Controller
                name="rolloverSameBgForwardCoverDate"
                control={control}
                render={({ field }) => (
                  <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
          </div>

          {/* FWD COVERED AMT Row */}
          <div className="row g-3 mt-2">
            <div className="col-12 col-lg-4">
              <div className="row align-items-center g-2">
                <label className="col-5 col-form-label de-label text-start">FWD COVERED AMT :</label>
                <div className="col-7">
                  <Controller
                    name="rolloverSameBgForwardCoveredAmt"
                    control={control}
                    render={({ field }) => <input {...field} type="number" className="form-control" />}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {rolloverType === 'new' && (
        <div className="mt-4 p-3 bg-light rounded border">
          <div className="row g-3">
            <div className="col-12 col-lg-4">
              <div className="row align-items-center g-2">
                <label className="col-5 col-form-label de-label text-start">UPFRONT CHARGES :</label>
                <div className="col-7">
                  <Controller
                    name="rolloverNewBgUpfrontCharges"
                    control={control}
                    render={({ field }) => <input {...field} type="number" className="form-control" />}
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-8">
              <div className="row align-items-center g-2">
                <label className="col-form-label de-label text-start de-label-span-2">FOR. BANK NAME :</label>
                <div className="de-input-span-2">
                  <Controller
                    name="rolloverNewBgForeignBankName"
                    control={control}
                    render={({ field }) => <input {...field} type="text" className="form-control" placeholder="Foreign Bank Name" />}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* M1 row */}
          <div className="de-form-grid de-cols-5 mt-3">
            <div className="de-field-group">
              <label className="de-label mb-1">M1 :</label>
              <Controller
                name="rolloverNewBgM1"
                control={control}
                render={({ field }) => <input {...field} type="text" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">M1 DATE :</label>
              <Controller
                name="rolloverNewBgM1Date"
                control={control}
                render={({ field }) => (
                  <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">M1 VALUE :</label>
              <Controller
                name="rolloverNewBgM1Value"
                control={control}
                render={({ field }) => <input {...field} type="number" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">M1 - DOM :</label>
              <Controller
                name="rolloverNewBgM1Dom"
                control={control}
                render={({ field }) => (
                  <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">M1 - MV :</label>
              <Controller
                name="rolloverNewBgM1Mv"
                control={control}
                render={({ field }) => <input {...field} type="text" className="form-control" />}
              />
            </div>
          </div>

          {/* M2 row */}
          <div className="de-form-grid de-cols-5 mt-3">
            <div className="de-field-group">
              <label className="de-label mb-1">M2 :</label>
              <Controller
                name="rolloverNewBgM2"
                control={control}
                render={({ field }) => <input {...field} type="text" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">M2 DATE :</label>
              <Controller
                name="rolloverNewBgM2Date"
                control={control}
                render={({ field }) => (
                  <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">M2 VALUE :</label>
              <Controller
                name="rolloverNewBgM2Value"
                control={control}
                render={({ field }) => <input {...field} type="number" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">M2 - DOM :</label>
              <Controller
                name="rolloverNewBgM2Dom"
                control={control}
                render={({ field }) => (
                  <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">M2 - MV :</label>
              <Controller
                name="rolloverNewBgM2Mv"
                control={control}
                render={({ field }) => <input {...field} type="text" className="form-control" />}
              />
            </div>
          </div>

          {/* BG charges row */}
          <div className="de-form-grid de-cols-5 mt-3">
            <div className="de-field-group">
              <label className="de-label mb-1">BG NUMBER :</label>
              <Controller
                name="rolloverNewBgBgNumber"
                control={control}
                render={({ field }) => <input {...field} type="text" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">BG DATE :</label>
              <Controller
                name="rolloverNewBgBgDate"
                control={control}
                render={({ field }) => (
                  <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">BG CHARGES :</label>
              <Controller
                name="rolloverNewBgBgCharges"
                control={control}
                render={({ field }) => <input {...field} type="number" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">SBLC INT & CHARGES :</label>
              <Controller
                name="rolloverNewBgSblcInterestCharges"
                control={control}
                render={({ field }) => <input {...field} type="number" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">DUE DATE :</label>
              <Controller
                name="rolloverNewBgDueDate"
                control={control}
                render={({ field }) => (
                  <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
          </div>

          {/* Advice row */}
          <div className="de-form-grid de-cols-5 mt-3">
            <div className="de-field-group">
              <label className="de-label mb-1">ADVICE :</label>
              <Controller
                name="rolloverNewBgAdvice"
                control={control}
                render={({ field }) => <input {...field} type="text" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">ADVICE GST :</label>
              <Controller
                name="rolloverNewBgAdviceGst"
                control={control}
                render={({ field }) => <input {...field} type="text" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">EXCHANGE RATE :</label>
              <Controller
                name="rolloverNewBgExchangeRate"
                control={control}
                render={({ field }) => <input {...field} type="number" className="form-control" />}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">BANK DEDUCT DATE :</label>
              <Controller
                name="rolloverNewBgBankDeductingDate"
                control={control}
                render={({ field }) => (
                  <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
            <div className="de-field-group">
              <label className="de-label mb-1">FWD COVER DATE :</label>
              <Controller
                name="rolloverNewBgForwardCoverDate"
                control={control}
                render={({ field }) => (
                  <input type="date" className="form-control" value={field.value || ''} onChange={(e) => field.onChange(e.target.value)} />
                )}
              />
            </div>
          </div>

          {/* FWD COVERED AMT Row */}
          <div className="row g-3 mt-2">
            <div className="col-12 col-lg-4">
              <div className="row align-items-center g-2">
                <label className="col-5 col-form-label de-label text-start">FWD COVERED AMT :</label>
                <div className="col-7">
                  <Controller
                    name="rolloverNewBgForwardCoveredAmt"
                    control={control}
                    render={({ field }) => <input {...field} type="number" className="form-control" />}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BankTab;
